import React from 'react';

function FirstPage() {
    return (
      <div style={{
        height: 'auto',
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        overflow: 'hidden' // 设置超出隐藏
      }}>
        <img src="/images/logo-login.png" alt="Logo" style={{ width: '150px', marginBottom: '-15px' }} />
        <div style={{ color: 'gray', fontSize: '12px' }}>—— 微短剧创作平台</div>
        <div style={{ color: 'black', fontSize: '18px', marginTop: '20px' }}>“ AI时代的超级故事机，邀您共创 ”</div>
        {/* <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop:'40px' }}>
          <img src="/images/we.jpg" alt="Logo" style={{ width: '110px', marginRight: '20px' }} />
          <div style={{ textAlign: 'left', fontSize:'8px'}}>
            <p style={{ fontFamily: 'Arial, sans-serif', fontSize: '10px' }}><strong>如需试用，请联系本公司</strong></p>
            <p>联系方式</p>
            <p>联系人：洪尘铄</p>
            <p>微信号：wxid_u12cde67idlc22</p>
            <p>手机号：13909500647</p>
          </div>
        </div> */}
        <button 
          onClick={() => window.location.href = '/story-select'}
          style={{
            position: 'fixed',
            bottom: '50px',
            padding: '10px 20px',
            fontSize: '16px',
            width: '55%',
            height: '80px',
            backgroundColor: 'black',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer'
          }}>
          开始写作
        </button>

      </div>
    );
  }

  export default FirstPage;